import { Button } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) =>
	createStyles({
		buttonProgress: {
			color: 'primary',
			position: 'absolute',
			top: '50%',
			left: '50%',
			marginTop: -16,
			marginLeft: -12,
		},
	}),
);

export default function LoadingButton(props) {
	const classes = useStyles();
	const { children, ...rest } = props;
	return (
		<Button {...rest}>
			{children}
			{rest?.loading && <CircularProgress size={30} className={classes.buttonProgress} />}
		</Button>
	);
}
